import { owlLoader } from 'assets/images';
import React from 'react';

interface CustomLoaderProps {
  show: boolean;
  title?: string;
}

const CustomOwlLoader: React.FC<CustomLoaderProps> = ({ show, title }) => {
  if (!show) {
    return null; // Return null if show is false to hide the loader
  }

  return (
    <div className='loader-container'>
      {title && <h4 className='loader-container__title'>{title}</h4>}

      <img src={owlLoader} alt='Loader' className='img-fluid' />
    </div>
  );
};

export default CustomOwlLoader;
